import {InboxOutlined} from '@ant-design/icons';
import Upload from 'antd/es/upload';
import {UploadChangeParam, UploadFile} from 'antd/es/upload/interface';
import cn from 'classnames';
import React, {forwardRef, useImperativeHandle, useState} from 'react';

import {useAfterEffect} from 'shared/hooks/use-after-effect';
import {IFormItemProps} from 'shared/types';
import {TStateSetter} from 'shared/types/generics';

import {UploadDropzoneFile} from './upload-dropzone-file';

import './upload-dropzone.less';

export enum EUploadDropzoneMode {
    single,
    multiple
}

interface IUploadDropzoneProps extends IFormItemProps {
    className?: cn.Argument;
    mode?: EUploadDropzoneMode;
    clearAfterChange?: boolean;
    handleOnChange?: (info: UploadChangeParam<UploadFile<any>>) => void;
}

export interface IUploadDropzoneRef {
    setFileList: TStateSetter<UploadFile[]>;
}

export const UploadDropzone = forwardRef<IUploadDropzoneRef, IUploadDropzoneProps>((
    {
        className,
        mode = EUploadDropzoneMode.multiple,
        onChange,
        clearAfterChange,
        handleOnChange,
    }: IUploadDropzoneProps,
    ref,
) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    useAfterEffect(() => {
        onChange?.(fileList, undefined);
    }, [fileList]);

    useImperativeHandle(ref, () => ({
        setFileList,
    }));

    return (
        <div className={cn('upload-dropzone', className)}>
            <Upload
                multiple={mode === EUploadDropzoneMode.multiple}
                name="file"
                // accept={ACCEPTABLE_FILE_EXTENSIONS}
                beforeUpload={() => false}
                fileList={fileList}
                onChange={values => {
                    handleOnChange?.(values);
                    if (mode === EUploadDropzoneMode.single) {
                        setFileList(clearAfterChange ? [] : [values.file]);
                        return;
                    }
                    setFileList(clearAfterChange ? [] : values.fileList);
                }}
            >
                {(() => {
                    const zoneJSX = (
                        <div className={cn('upload-dropzone__zone')}>
                            <div className={cn('upload-dropzone__zone__icon')}>
                                <InboxOutlined
                                    color="red"
                                    style={{lineHeight: '20px'}}
                                />
                            </div>
                            <div className={cn('upload-dropzone__zone__tip')}>
                                Перетащите файлы или нажмите, чтобы добавить вложение
                            </div>
                        </div>
                    );

                    if (mode === EUploadDropzoneMode.single && fileList.length) return null;
                    return zoneJSX;
                })()}

            </Upload>

            {!!fileList.length && (
                <div className="upload-dropzone__file-list">
                    {fileList.map(file => (
                        <UploadDropzoneFile
                            file={file}
                            setFileList={setFileList}
                        />
                    ))}
                </div>
            )}
        </div>
    );
});
